import {
  useMediaQuery, useTheme,
} from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faAngleUp,
} from '@fortawesome/free-solid-svg-icons';
import {
  Link,
} from 'react-router-dom';
import { useContext, useEffect, useState } from 'react';
import { LayoutContext } from '../contexts/LayoutContext';
import { useUserContext } from '../contexts/UserContext';
import SideBar from './SideBar';
import LogoutModal from './logoutModal';
import { MyMenu } from './MyMenu';

type Props = {
  children?: React.ReactNode
};

export const PrivateLayout: React.FC<Props> = ({ children }) => {
  const { layout } = useContext(LayoutContext);
  const [openSideBar, setOpenSideBar] = useState(true);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const [logoutModalOpen, setLogoutModalOpen] = useState(false);
  const { user, logoutUser } = useUserContext();

  useEffect(() => {
    if (isMobile) {
      setOpenSideBar(false);
    } else {
      setOpenSideBar(true);
    }
  }, [isMobile]);

  return (
    <div data-theme="jasv">
      <div className="wrapper">
        <SideBar open={openSideBar} handleLogoutModalOpen={() => setLogoutModalOpen(true)} />
        <LogoutModal
          open={logoutModalOpen}
          handleClose={() => setLogoutModalOpen(false)}
          handleSave={() => {
            logoutUser();
            setLogoutModalOpen(false);
          }}
        />
        <div className="main">

        <nav className="navbar navbar-expand navbar-light navbar-bg">

          {!layout && (
<>
          <Link to="#" className="sidebar-toggle js-sidebar-toggle" style={{ cursor: 'pointer' }} onClick={() => setOpenSideBar((o) => !o)}>
            {openSideBar && (<i className="fa-solid fa-chevron-left align-self-center" />)}
            {!openSideBar && (<i className="fa-solid align-self-center fa-chevron-right" />)}
          </Link>

          <MyMenu name={user?.name || ''} hasMenu />
</>
          )}

          {layout && (<>{layout}</>)}

        </nav>

          <footer className="footer d-none">
            <div className="container-fluid">
              <div className="row text-muted">
                <div className="col-6 text-start">
                  &copy; 2022 JASV
                </div>
                <div className="col-6 text-end">
                  <div className="d-none d-sm-block">Version 1.0.0</div>
                </div>
              </div>
            </div>
          </footer>
          <a className="scroll-to-top rounded"><FontAwesomeIcon icon={faAngleUp} /></a>
          {children}
        </div>
      </div>
    </div>
  );
};

export default PrivateLayout;
